import { CSSProperties } from 'react';

export const truncateSpanStyle: CSSProperties = {
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
